<template>
  <el-header
    height="60px"
    class="layout-header">
    <div class="layout-header-title">大健康服务</div>
    <div class="header-menu">
      <!-- <el-menu
        :default-active="active"
        background-color="#2e353f"
        text-color="#fff"
        active-text-color="#ffd04b"
        mode="horizontal">
        <el-menu-item
          v-for="item in menu"
          :key="item.menuId"
          style="padding: 0 8px"
          :index="item.menuId + ''"
          @click="openUrl(item.funcAddress)">{{ item.menuName }}</el-menu-item>
      </el-menu> -->
    </div>
    <div class="layout-header-user">
      <el-dropdown trigger="click">
        <span class="el-dropdown-link">
          {{ userInfo.account }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="logout">退出登陆</el-dropdown-item>
          <el-dropdown-item @click.native="updatePwd">修改密码</el-dropdown-item>
          <!-- <el-dropdown-item @click.native="setEntPic">图文信息设置</el-dropdown-item> -->
        </el-dropdown-menu>
      </el-dropdown>
      <password-modal
        ref="modal"
        :account="userInfo.account" />
    </div>
    <!-- <ent-pic-modal ref="ent" /> -->
  </el-header>
</template>
<script>
import { mapState } from 'vuex'
// import EntPicModal from './ent-pic-modal.vue'
import PasswordModal from './password-modal.vue'
export default {
  name: 'LayoutHeader',
  components: { PasswordModal },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo,
      permission: (state) => state.account.permission
      // menu: (state) => state.account.menu
    })
    // active() {
    //   return this.$route.meta.activeTopPath + ''
    // }
  },
  mounted() {
    if (this.userInfo.needChangePassword) {
      this.$refs.modal.forceUpdate()
    }
  },
  methods: {
    openUrl(url) {
      this.$router.push(url)
    },
    logout() {
      this.$store.dispatch('account/logout', {
        payload: {},
        success: () => {
          this.$router.push({ path: '/login' })
        }
      })
    },
    setEntPic() {
      this.$refs.ent.getkeyvaluebykey()
    },
    // entInfo() {
    //   this.$router.push('/vendordetail?vendorId=' + this.userInfo.orgId)
    // },
    // labInfo() {
    //   this.$router.push('/labdetail?labId=' + this.userInfo.orgId)
    // },
    // agencyInfo() {
    //   this.$router.push('/agencydetail?seaportId=' + this.userInfo.orgId)
    // },
    updatePwd() {
      this.$refs.modal.toggleModal(true)
    }
  }
}
</script>
<style lang="stylus" scoped>
.layout-header {
  padding: 0 20px;
  display: flex;
  align-items: center;
  background: #2e353f;
  // justify-content: space-between;
  box-shadow: 0 0 6px rgba(0, 21, 41, 0.2);
  z-index: 9;

  .layout-header-title {
    width 180px;
    font-size: 21px;
    font-weight: 900;
    // margin-left: 20px;
    letter-spacing: 3px;
    color: #fff;
  }

  .header-menu {
    flex: 1;
    // margin-left: 36px;

    .el-menu-item {
      font-size 16px;
      font-weight bold
    }
  }

  .layout-header-user {
    display: flex;
    align-items: center;

    .el-dropdown-link {
      cursor: pointer;
      color: #fff;
    }
  }
}
</style>
